import type { EditVoucherModel } from './model';

export const VouchersComponent = {
    MountAsync: async (target: HTMLElement, props: { voucherId?: string; }) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { VouchersComponent } = await import('./VouchersComponent');
        return await mountReactComponentAsync(target, VouchersComponent, props);
    }
};
